<h1 class="form-title">Saisir le Médiateur de l'eau</h1>
<form id="regForm" name="regForm" formgroup="form" enctype="multipart/form-data"> 
    <router-outlet></router-outlet>
</form>
